import { PlanningUnitFormDto, type PlanningUnitFormInterface } from '@zaoblako/shared/common/dtos/planning-unit/planning-unit-form.dto';
import { ReminderFormDto, type ReminderFormInterface } from '@zaoblako/shared/modules/notification/dtos/reminder/reminder.form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DebtsDtoKeysEnum } from '@zaoblako/shared/modules/debts/enums/debts-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { MasterMilestoneFindInterface } from '@zaoblako/shared/modules/catalog/dtos/master-milestone/master-milestone-find.dto';
import type { DebtCollectionTaskEventTypeFindInterface } from '@zaoblako/shared/modules/debts/dtos/debt-collection-task-event-type/debt-collection-task-event-type-find.dto';

import * as yup from 'yup';

/** Debt collection task event update API request body - DTO signature */
export interface DebtCollectionTaskEventFormInterface {
  /** Task event display name */
  name: string;
  /** Task event additional description */
  description?: string;
  /** Task event start date and time (current by default) */
  startAt?: Date;
  /** Task event start date and time (current plus one hour by default) */
  endAt?: Date;
  /** Task event type */
  type?: DebtCollectionTaskEventTypeFindInterface;
  /** Related master milestone */
  masterMilestone?: MasterMilestoneFindInterface;
  /** Task event responsible users */
  responsible?: UserFindInterface[];
  /** Reminder for event responsible users */
  reminder?: ReminderFormInterface;
  /** Task event repeat schedule */
  planning?: PlanningUnitFormInterface;
}

/** Debt collection task event update API request body - DTO schema */
export const DebtCollectionTaskEventFormDto = SerdeDtoClass.create<DebtCollectionTaskEventFormInterface>(DebtsDtoKeysEnum.DEBT_COLLECTION_TASK_EVENT_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  startAt: {
    optional: true,
    label: 'Дата начала',
    serializer: yup.date(),
  },
  endAt: {
    optional: true,
    label: 'Планируемая дата завершения',
    serializer: yup.date(),
  },
  type: {
    optional: true,
    label: 'Тип события',
    serializer: entityLikeSchema,
  },
  masterMilestone: {
    optional: true,
    label: 'Эпик',
    serializer: entityLikeSchema,
    checkers: [CatalogCheckersEnum.MASTER_MILESTONE_ASSERT_EXISTS_BY_DTO],
  },
  responsible: {
    optional: true,
    label: 'Ответственные',
    serializer: yup.array(entityLikeSchema),
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
  },
  reminder: {
    optional: true,
    nested: ReminderFormDto,
    label: 'Напоминание',
    serializer: (_, nested) => nested,
  },
  planning: {
    optional: true,
    nested: PlanningUnitFormDto,
    label: 'Повтор',
    serializer: (_, nested) => nested,
  },
});
